var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-logo-linkedin",
    "data-name": "Icon ionic-logo-linkedin",
    d: "M32.1,4.5H7.063A2.447,2.447,0,0,0,4.5,6.837V31.929A2.64,2.64,0,0,0,7.063,34.5h25.03A2.506,2.506,0,0,0,34.5,31.929V6.837A2.3,2.3,0,0,0,32.1,4.5ZM13.8,29.506H9.5V16.144h4.3Zm-2-15.395h-.031A2.206,2.206,0,0,1,9.5,11.807,2.22,2.22,0,0,1,11.822,9.5a2.214,2.214,0,0,1,2.3,2.305A2.219,2.219,0,0,1,11.8,14.112ZM29.506,29.506h-4.3V22.2c0-1.75-.625-2.946-2.18-2.946a2.352,2.352,0,0,0-2.2,1.586,2.894,2.894,0,0,0-.148,1.055v7.611h-4.3V16.144h4.3V18a4.351,4.351,0,0,1,3.876-2.172c2.821,0,4.954,1.86,4.954,5.869v7.807Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6023684eb4a2bf65d49637ba4ef350d0.svg";
export { ForwardRef as ReactComponent };